import * as constants from '../constants/ActionTypes';

const initialState = {
  callUsResult: undefined,
  isLoading: true,
  display: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.REQUEST_CALLUS:
      return Object.assign({}, state, { isLoading: true, display: false });
    case constants.RECEIVE_CALLUS_RESPONSE:
      return Object.assign({}, state, { callUsResult: action.payload, isLoading: false, display: true });
    case constants.RECEIVE_CALLUS_ERROR :
      return Object.assign({}, state, { isLoading: false, display: true });
    case constants.LOGIN_EMAIL :
      return Object.assign({}, state, { display: false, callUsResult: undefined });
    default :
      return state;
  }
}
